import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import type { SharedRuntimeConfig } from '@repo/shared-config/environment';
import type { AppConfig } from '@repo/shared-kit/config/types';

const EMPTY_EXTRA: Record<string, never> = {};

export function fromEmberConfig(env: SharedRuntimeConfig): AppConfig {
  const { backendUrlsTable, frontendUrlsTable } = getUrlsTable(env);

  return {
    environment: {
      mode: env.environment,
      deployTarget: env.deployTarget,
      isProduction: env.isProduction,
      isStaging: env.isStaging,
    },
    urls: {
      apiBaseURL: backendUrlsTable.apiBaseURL,
      appJsURL: frontendUrlsTable.appJsURL,
      authBaseURL: backendUrlsTable.authBaseURL,
      billerBaseURL: backendUrlsTable.billerBaseURL,
      clientPortalURL: frontendUrlsTable.clientPortalURL,
      companyCreationBaseURL: backendUrlsTable.companyCreationBaseURL,
      companyCreationJsURL: frontendUrlsTable.companyCreationJsURL,
      cookieDomain: backendUrlsTable.cookieDomain,
      hubBaseURL: backendUrlsTable.hubBaseURL,
      landingURL: backendUrlsTable.landingURL,
      notifierBaseURL: backendUrlsTable.notifierBaseURL,
      oAuthBaseUrl: backendUrlsTable.oAuthBaseUrl,
      oAuthClientUrl: backendUrlsTable.oAuthClientUrl,
      receivableInvoicesURL: frontendUrlsTable.receivableInvoicesURL,
      registerBaseURL: backendUrlsTable.registerBaseURL,
      registerJsURL: frontendUrlsTable.registerJsURL,
      registerPartnersBaseURL: backendUrlsTable.registerPartnersBaseURL,
      registerPartnersJsURL: frontendUrlsTable.registerPartnersJsURL,
      thirdPartyBaseURL: backendUrlsTable.thirdPartyBaseURL,
      verificationBaseURL: backendUrlsTable.verificationBaseURL,
      websocketBaseURL: backendUrlsTable.websocketBaseURL,
    },
    services: {
      checkout: env.checkout,
      googleAuth: env.googleAuth,
      appleAuth: env.appleAuth,
      googlePay: env.googlePay,
      refinerProjectId: env.refinerProjectId,
      qontoEventGatewayUrl: env.qontoEventGatewayUrl,
      segment: env.metricsAdaptersConfig?.Segment.config,
      stagingAccessToken: env.stagingAccessToken,
    },
    extra: EMPTY_EXTRA,
  };
}
